import React from 'react';
import styled from 'styled-components';

import Section from '../../../../common/Section';

import Pricing from './details/Pricing';
import Support from './details/Support';

const Details = (props) => {
  const { app } = props;
  const { salesDescription, description } = app;

  return (
    <Section>
      <StyledDetails>
        <StyledMain>
          <StyledTitle>Description</StyledTitle>
          {description ? (
            // eslint-disable-next-line react/no-danger
            <StyledDescription
              dangerouslySetInnerHTML={{ __html: description }}
            />
          ) : (
            <StyledSalesDescription>{salesDescription}</StyledSalesDescription>
          )}
        </StyledMain>
        <StyledSide>
          <Pricing app={app} />
          <Support app={app} />
        </StyledSide>
      </StyledDetails>
    </Section>
  );
};

const StyledDescription = styled.div`
  p,
  div {
    margin: 1em 0;
  }

  ul {
    list-style: initial;
    margin: 10px 0 20px 30px;
  }

  p strong,
  strong,
  b {
    font-weight: var(--font-weight-bold);
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: var(--font-weight-bold);
  }
  h1 {
    font-size: var(--heading-size-sm);
  }
  h2 {
    font-size: var(--heading-size-xs);
  }
  h3 {
    font-size: var(--font-size-lg);
  }
  h4 {
    font-size: var(--font-size-base);
  }
  h5 {
    font-size: var(--font-size-sm);
  }
  li {
    margin-bottom: 5px;
  }

  i {
    font-style: italic;
  }
`;

const StyledMain = styled.div`
  flex-basis: 75%;
`;

const StyledSide = styled.div`
  flex-basis: 25%;
  display: flex;
  flex-direction: column;
  gap: 60px;
`;

const StyledTitle = styled.h2`
  font-size: var(--heading-size-base);
  font-weight: var(--font-weight-bold);
  color: var(--blue-dark);
  margin-bottom: 15px;
`;

const StyledDetails = styled.div`
  padding-top: 90px;
  padding-bottom: 160px;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${({ theme }) => theme.largeUp} {
    flex-direction: row;
  }
`;

const StyledSalesDescription = styled.p`
  color: var(--black);
  font-size: var(--font-size-lg);
  line-height: 1.5;
  margin-bottom: 25px;
`;

export default Details;
